<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/iam' }">
        <app-i18n code="iam.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="iam.new.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      route-name="iam"
      :route-params="{ tabName: 'managers' }"
      i18nCode="staff.tabs.managers"
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="iam.new.title"></app-i18n>
    </h1>

    <div class="app-content-page">
      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >
        <el-row :gutter="10">
          <!-- Emails -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.emails.label"
              :prop="fields.emails.name"
              :required="fields.emails.required"
            >
              <emails-input
                v-if="model[fields.emails.name]"
                v-model="model[fields.emails.name]"
                :placeholder="i18n('iam.placeholders.email')"
                prefix-icon="icon-mail"
              ></emails-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- groups -->
        <el-row :gutter="10">
          <!-- Manage Type -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.manageType.label"
              :prop="fields.manageType.name"
              :required="fields.manageType.required"
            >
              <el-radio-group v-model="model[fields.manageType.name]">
                <el-radio
                  :key="option"
                  :label="option"
                  :value="option"
                  @change="onChange"
                  v-for="option of fields.manageType.values(currentManage.type)"
                >{{i18n(`user.fields.${option}`)}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- Property -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :disable="true"
              :label="fields.property.label"
              :prop="fields.property.name"
              :required="manage.property.required"
              v-if="manage.property.required"
            >
              <app-autocomplete-one-input
                :fetchFn="fields.property.fetchFn"
                v-model="model[fields.property.name]"
                :disabled="manage.property.disabled"
                prefix-icon="icon-cup"
              ></app-autocomplete-one-input>
            </el-form-item>
          </el-col>

          <!-- Subproperty -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.subproperty.label"
              :prop="fields.subproperty.name"
              :required="manage.subproperty.required"
              v-if="manage.subproperty.required && model[fields.property.name]"
            >
              <app-autocomplete-one-input
                :fetchFn="fields.subproperty.fetchFn"
                :key="manage.subproperty.key"
                :manage="manage.property.values"
                :disabled="manage.subproperty.disabled"
                v-model="model[fields.subproperty.name]"
                prefix-icon="icon-cup"
              ></app-autocomplete-one-input>
            </el-form-item>
          </el-col>

          <!-- Program -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.program.label.many"
              :prop="fields.program.name"
              :required="manage.program.required"
              v-if="manage.program.required && model[fields.subproperty.name]"
            >
              <app-autocomplete-one-input
                :fetchFn="fields.program.fetchFn"
                :key="manage.program.key"
                :manage="manage.subproperty.values"
                :disabled="manage.program.disabled"
                v-model="model[fields.program.name]"
              ></app-autocomplete-one-input>
            </el-form-item>
          </el-col>

          <!-- Subprogram -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.subprogram.label"
              :prop="fields.subprogram.name"
              :required="manage.subprogram.required"
              v-if="manage.subprogram.required && model[fields.program.name]"
            >
              <app-autocomplete-one-input
                :fetchFn="fields.subprogram.fetchFn"
                :key="manage.subprogram.key"
                :manage="manage.program.values"
                :disabled="manage.subprogram.disabled"
                v-model="model[fields.subprogram.name]"
              ></app-autocomplete-one-input>
            </el-form-item>
          </el-col>

          <!-- Roles -->
          <el-col :lg="11" :md="16" :sm="24">
            <el-form-item
              :label="fields.rolesRequired.label"
              :prop="fields.rolesRequired.name"
              :required="fields.rolesRequired.required"
            >
              <el-select
                :placeholder="i18n(`iam.placeholders.${fields.rolesRequired.name}`)"
                :key="keyRoleComponent"
                multiple
                v-model="model.roles"
              >
                <el-option
                  :key="option"
                  :label="roleLabelOf(option)"
                  :value="option"
                  v-for="option in fields.rolesRequired.values(manage.type)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Actions -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item>
              <div class="form-buttons">
                <el-button :disabled="saveLoading" @click="doSubmit" type="primary">
                  <app-i18n code="common.create"></app-i18n>
                </el-button>

                <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
                <app-i18n code="common.reset"></app-i18n>
                </el-button>-->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { UserModel } from '@modules/auth/user-model';
import { i18n } from '@shared/i18n';
import Roles from '@security/roles';
import ManageFactory from '@shared/factories/manage-factory';
import objectPath from 'object-path';

export default {
  name: 'app-iam-new-page',

  data() {
    return {
      model: {},
      keyRoleComponent: 0,
      manage: {
        type: '',
        property: {
          key: 0, // for render de component when change value
          show: false, // for show a component
          values: {},
          required: false,
          value: null,
        },
        subproperty: {
          key: 0,
          show: false,
          values: {},
          required: false,
          value: null,
        },
        program: {
          key: 0,
          show: false,
          values: {},
          required: false,
          value: null,
        },
        subprogram: {
          key: 0,
          show: false,
          values: {},
          required: false,
          value: null,
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      currentProperty: 'auth/currentProperty',
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      saveLoading: 'iam/form/saveLoading',
      record: 'iam/form/record',
      currentUser: 'auth/currentUser',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    isUniqueEmail() {
      return (
        !this.model ||
        !this.model.emails ||
        this.model.emails.length <= 1
      );
    },

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.emails,
        fields.rolesRequired,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },
  },

  async created() {
    const { formSchema } = this;
    await this.doNew();
    this.model = formSchema.initialValues(this.record);
    this._loadModelPerManage();
  },

  methods: {
    ...mapActions({
      doNew: 'iam/form/doNew',
      doAdd: 'iam/form/doAdd',
    }),

    _loadModelPerManage() {
      if (this.currentManage.type == 'property') {
        objectPath.set(
          this.manage,
          'property.disabled',
          true,
        );
        objectPath.set(this.model, 'property', {
          id: this.currentManage.property.id,
        });
      }
      if (this.currentManage.type == 'subproperty') {
        objectPath.set(
          this.manage,
          'property.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'subproperty.disabled',
          true,
        );
        objectPath.set(this.model, 'property', {
          id: this.currentManage.property.id,
        });
        objectPath.set(this.model, 'subproperty', {
          required: false,
          id: this.currentManage.subproperty.id,
        });
      }
      if (this.currentManage.type == 'program') {
        objectPath.set(
          this.manage,
          'property.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'subproperty.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'program.disabled',
          true,
        );
        objectPath.set(this.model, 'property', {
          id: this.currentManage.property.id,
        });
        objectPath.set(this.model, 'subproperty', {
          required: false,
          id: this.currentManage.subproperty.id,
        });
        objectPath.set(this.model, 'program', {
          id: this.currentManage.program.id,
        });
      }
      if (this.currentManage.type == 'subprogram') {
        objectPath.set(
          this.manage,
          'property.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'subproperty.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'program.disabled',
          true,
        );
        objectPath.set(
          this.manage,
          'subprogram.disabled',
          true,
        );

        objectPath.set(this.model, 'subprogram', {
          id: this.currentManage.subprogram.id,
        });
      }
    },

    // doReset() {
    //   this.model = formSchema.initialValues();
    //   this.$refs.form.resetFields();
    // },

    onChange(manageType) {
      // Change manage type
      this.manage.type = manageType;
      const manageRequiredOptions = new ManageFactory(
        manageType,
      ).manageUserFormShow;

      this.manage.property.required =
        manageRequiredOptions.property;
      this.manage.subproperty.required =
        manageRequiredOptions.subproperty;
      this.manage.program.required =
        manageRequiredOptions.program;
      this.manage.subprogram.required =
        manageRequiredOptions.subprogram;
      // Remove role data
      delete this.model.roles;
      // Rerender role component
      this.keyRoleComponent += 1;
    },
    async doSubmit() {
      const { formSchema } = this;
      
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      // Create manage param
      const manage = {
        type: this.manage.type,
        propertyId: objectPath.get(
          this.model,
          'property.id',
          null,
        ),
        subpropertyId: objectPath.get(
          this.model,
          'subproperty.id',
          null,
        ),
        programId: objectPath.get(
          this.model,
          'program.id',
          null,
        ),
        subprogramId: objectPath.get(
          this.model,
          'subprogram.id',
          null,
        ),
      };

      const { ...values } = formSchema.cast(this.model);

      // Delete fields unnecesary
      delete values.manageType;
      delete values.property;
      delete values.subproperty;
      delete values.program;
      delete values.subprogram;

      return this.doAdd({ values, manage });
    },

    roleDescriptionOf(roleId) {
      return Roles.descriptionOf(roleId);
    },

    roleLabelOf(roleId) {
      return Roles.labelOf(roleId);
    },
    i18n(code) {
      return i18n(code);
    },
    listManageTypes() {
      return ['property', 'program'];
    },
    handleClickTabRoles(tab, event) {
      console.log(tab, event);
    },
  },

  watch: {
    'model.property.id'(newId, oldId) {
      this.manage.property.values.propertyId = newId;
      this.manage.property.values.type = 'property';
      this.manage.subproperty.key += 1;
      this.manage.program.key += 1;
      this.manage.subprogram.key += 1;
      console.log(
        `TODO: if property load, then load subproperty newId:${newId} oldId:${oldId}`,
      );
    },
    'model.subproperty.id'(newId, oldId) {
      this.manage.subproperty.values = this.manage.property.values;
      this.manage.subproperty.values.subpropertyId = newId;
      this.manage.subproperty.values.type = 'subproperty';

      this.manage.program.key += 1;
      this.manage.subprogram.key += 1;
      console.log(
        `TODO: if subproperty load, then load programs newId:${newId} oldId:${oldId}`,
      );
    },
    'model.program.id'(newId, oldId) {
      this.manage.program.values = this.manage.subproperty.values;
      this.manage.program.values.programId = newId;
      this.manage.program.values.type = 'program';
      this.manage.subprogram.key += 1;
      console.log(
        `TODO: if program load, then load subprogram newId:${newId} oldId:${oldId}`,
      );
    },
    'model.subprogram.id'(newId, oldId) {
      this.manage.subprogram.values = this.manage.program.values;
      this.manage.subprogram.values.subprogramId = newId;
      this.manage.subprogram.values.type = 'subprogram';
      console.log(
        `TODO: if subprogram load, then load programs newId:${newId} oldId:${oldId}`,
      );
    },
  },
};
</script>